<template>

  <div>

    <!-- Encabezado -->

    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">

      <div>

        <h2 class="text-2xl font-bold text-slate-800">Sistemas</h2>

        <p class="text-slate-500 text-sm mt-1">Gestiona los sistemas/servicios que ofrece MADAV Solutions.</p>

      </div>

      <button

        @click="abrirNuevo"

        class="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-xl font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 self-start sm:self-auto"

      >

        <i class="fa-solid fa-plus"></i>

        Nuevo Sistema

      </button>

    </div>



    <!-- Tabla -->

    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">

      <div class="overflow-x-auto">

        <table class="w-full text-sm">

          <thead>

            <tr class="bg-slate-50 border-b border-slate-200">

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">#</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Icono</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Nombre</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Descripción</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Gradiente</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Estatus</th>

              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Acciones</th>

            </tr>

          </thead>

          <tbody class="divide-y divide-slate-100">

            <tr v-if="cargando">

              <td colspan="7" class="px-6 py-12 text-center text-slate-400">

                <i class="fa-solid fa-spinner fa-spin text-2xl text-emerald-400 mr-2"></i>

                Cargando...

              </td>

            </tr>

            <tr v-else-if="sistemas.length === 0">

              <td colspan="7" class="px-6 py-12 text-center text-slate-400">

                <i class="fa-solid fa-inbox text-3xl mb-2 block"></i>

                No hay sistemas registrados

              </td>

            </tr>

            <tr

              v-else

              v-for="(item, idx) in sistemas"

              :key="item.idSistema"

              class="hover:bg-slate-50 transition-colors duration-150"

            >

              <td class="px-6 py-4 text-slate-400 text-xs">{{ idx + 1 }}</td>

              <td class="px-6 py-4 text-2xl">{{ item.icono }}</td>

              <td class="px-6 py-4 font-semibold text-slate-800">{{ item.nombre }}</td>

              <td class="px-6 py-4 text-slate-500 max-w-xs truncate">{{ item.descripcion }}</td>

              <td class="px-6 py-4">

                <div

                  class="w-24 h-6 rounded-full"

                  :style="{ background: item.gradiente }"

                ></div>

              </td>

              <td class="px-6 py-4">

                <span :class="['inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold',

                               item.estatus === 'A' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600']">

                  <span :class="['w-1.5 h-1.5 rounded-full', item.estatus === 'A' ? 'bg-emerald-500' : 'bg-red-500']"></span>

                  {{ item.estatus === 'A' ? 'Activo' : 'Inactivo' }}

                </span>

              </td>

              <td class="px-6 py-4">

                <div class="flex items-center gap-2">

                  <button

                    @click="editar(item)"

                    class="p-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 transition-colors duration-150"

                    title="Editar"

                  >

                    <i class="fa-solid fa-pen-to-square text-xs"></i>

                  </button>

                  <button

                    @click="verPlanes(item)"

                    class="p-2 rounded-lg bg-green-50 hover:bg-green-100 text-green-600 transition-colors duration-150"

                    title="Ver planes"

                  >

                    <i class="fa-solid fa-box-open text-xs"></i>

                  </button>

                  <button

                    @click="cambiarEstatus(item)"

                    :class="['p-2 rounded-lg transition-colors duration-150',

                             item.estatus === 'A'

                               ? 'bg-red-50 hover:bg-red-100 text-red-500'

                               : 'bg-emerald-50 hover:bg-emerald-100 text-emerald-600']"

                    :title="item.estatus === 'A' ? 'Desactivar' : 'Activar'"

                  >

                    <i :class="['text-xs', item.estatus === 'A' ? 'fa-solid fa-ban' : 'fa-solid fa-check']"></i>

                  </button>

                </div>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>



    <!-- Modal -->

    <transition name="modal">

      <div v-if="modalVisible" class="fixed inset-0 z-50 flex items-center justify-center modal-overlay p-4">

        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-xl animate-fade-in flex flex-col" style="max-height: calc(100vh - 2rem)">

          <!-- Header modal -->

          <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100">

            <h3 class="font-bold text-slate-800 text-lg">

              <i class="fa-solid fa-laptop-code text-emerald-500 mr-2"></i>

              {{ modoEdicion ? 'Editar Sistema' : 'Nuevo Sistema' }}

            </h3>

            <button @click="cerrarModal" class="text-slate-400 hover:text-slate-600 p-1">

              <i class="fa-solid fa-xmark text-lg"></i>

            </button>

          </div>



          <!-- Cuerpo modal -->

          <div class="px-6 py-5 space-y-4 overflow-y-auto flex-1">

            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">Nombre <span class="text-red-500">*</span></label>

              <input

                v-model="form.nombre"

                type="text"

                maxlength="100"

                placeholder="Ej. Punto de Venta"

                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"

              />

            </div>



            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">Descripción <span class="text-red-500">*</span></label>

              <textarea

                v-model="form.descripcion"

                rows="3"

                maxlength="500"

                placeholder="Descripción del sistema..."

                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent resize-none transition-all"

              ></textarea>

            </div>

            <!-- URL -->
            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-1">
                <i class="fa-solid fa-link text-emerald-500 mr-1"></i>
                URL del sistema
              </label>

              <input
                v-model="form.url"
                type="text"
                maxlength="300"
                placeholder="Ej. http://localhost:8082"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />

            </div>

            <div class="grid grid-cols-2 gap-4">

              <div>

                <label class="block text-sm font-semibold text-slate-700 mb-1">Icono (emoji)</label>

                <!-- Selector de iconos -->
                <div class="grid grid-cols-6 gap-1 p-2 bg-slate-50 border border-slate-200 rounded-xl mb-2 max-h-28 overflow-y-auto">
                  <button
                    v-for="ic in iconosDisponibles"
                    :key="ic"
                    type="button"
                    @click="form.icono = ic"
                    :class="['text-xl p-1 rounded-lg transition-all duration-150 hover:bg-emerald-100',
                             form.icono === ic ? 'bg-emerald-200 ring-2 ring-emerald-400 scale-110' : '']"
                    :title="ic"
                  >{{ ic }}</button>
                </div>
                <!-- Campo manual por si necesitan un emoji personalizado -->
                <input
                  v-model="form.icono"
                  type="text"
                  maxlength="10"
                  placeholder="O escribe un emoji???"
                  class="w-full border border-slate-300 rounded-xl px-3 py-2 text-xl text-center focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
                />

              </div>

              <div>

                <label class="block text-sm font-semibold text-slate-700 mb-1">Vista previa</label>

                <div

                  class="w-full rounded-xl flex flex-col items-center justify-center text-white font-semibold gap-1 py-3"

                  :style="{ background: form.gradiente || 'linear-gradient(135deg,#6366f1,#8b5cf6)' }"

                >
                  <span class="text-3xl leading-none">{{ form.icono || '?"' }}</span>
                  <span class="text-xs opacity-80 truncate max-w-full px-2">{{ form.nombre || 'Vista previa' }}</span>
                </div>

              </div>

            </div>



            <div>

              <label class="block text-sm font-semibold text-slate-700 mb-2">Color del gradiente</label>

              <div class="grid grid-cols-4 gap-2">

                <button

                  v-for="g in gradientesDisponibles"

                  :key="g.nombre"

                  @click="form.gradiente = g.valor"

                  :class="['h-10 rounded-xl transition-all duration-200 hover:scale-105 border-2',

                           form.gradiente === g.valor ? 'border-slate-800 scale-105' : 'border-transparent']"

                  :style="{ background: g.valor }"

                  :title="g.nombre"

                ></button>

              </div>

            </div>

          </div>

            <!-- Footer modal -->

          <div class="flex justify-end gap-3 px-6 py-4 border-t border-slate-100">

            <button

              @click="cerrarModal"

              class="px-5 py-2.5 rounded-xl border border-slate-300 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-all"

            >Cancelar</button>

            <button

              @click="guardar"

              :disabled="guardando"

              class="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed"

            >

              <i v-if="guardando" class="fa-solid fa-spinner fa-spin mr-1"></i>

              {{ guardando ? 'Guardando...' : 'Guardar' }}

            </button>

          </div>

        </div>

      </div>

    </transition>

  </div>

</template>



<script>

import servicio from '@/services/sistemas.service'



export default {

  name: 'SistemasAdmin',

  data () {

    return {

      sistemas:     [],

      cargando:     false,

      guardando:    false,

      modalVisible: false,

      modoEdicion:  false,

      form: {

        idSistema:   0,

        nombre:      '',

        descripcion: '',

        icono:       '???',

        gradiente:   'linear-gradient(135deg, #6366F1, #8B5CF6)',

        url:         ''

      },

      gradientesDisponibles: [

        { nombre: '�ndigo/Violeta',  valor: 'linear-gradient(135deg, #6366F1, #8B5CF6)' },

        { nombre: 'Azul/�ndigo',     valor: 'linear-gradient(135deg, #3B82F6, #1D4ED8)' },

        { nombre: 'Cian/Teal',       valor: 'linear-gradient(135deg, #06B6D4, #0E7490)' },

        { nombre: 'Verde/Esmeralda', valor: 'linear-gradient(135deg, #10B981, #065F46)' },

        { nombre: 'Naranja/Rojo',    valor: 'linear-gradient(135deg, #F97316, #C2410C)' },

        { nombre: 'Rojo/Rosa',       valor: 'linear-gradient(135deg, #EF4444, #991B1B)' },

        { nombre: 'Rosa/Violeta',    valor: 'linear-gradient(135deg, #EC4899, #7C3AED)' },

        { nombre: 'Amarillo/Naranja',valor: 'linear-gradient(135deg, #F59E0B, #D97706)' }

      ],

      iconosDisponibles: [
        '🏥','🦷','💊','🩺','🧬','🥊','🧘','🤸','⚽','🏃',
        '🛒','🏪','💳','📦','🏷️','🍽️','🍕','☕','🍔','🥗',
        '💇','💅','🧴','👗','🎓','📚','✏️','🏫','🖥️','💻',
        '📱','🖨️','🏠','🔧','⚙️','🔑','🚗','🚕','✈️','🚢',
        '🏨','💼','📊','📈','🎯','💡','🎵','🎮','🎨','📷',
        '🌍','🌱','🌸','🐶','🧩','🏋️','🎪','🏆','⭐','🔔'
      ]

    }

  },

  mounted () {

    this.cargar()

  },

  methods: {

    async cargar () {

      this.cargando = true

      try {

        const res = await servicio.sistemasCon()

        console.log('Respuesta sistemas:', res)

        this.sistemas = res.data.sistemas || res.data || []

      } catch (error) {

        console.error('Error al cargar sistemas:', error.response || error.message)

        this.$store.dispatch('mostrarToast', { mensaje: `Error: ${error.response?.data?.message || error.message}`, tipo: 'error' })

      } finally {

        this.cargando = false

      }

    },



    abrirNuevo () {

      this.modoEdicion       = false

      this.form.idSistema    = 0

      this.form.nombre       = ''

      this.form.descripcion  = ''

      this.form.icono        = '?Y-??'

      this.form.gradiente    = 'linear-gradient(135deg, #6366F1, #8B5CF6)'

      this.form.url          = ''

      this.modalVisible      = true

    },



    editar (item) {

      this.modoEdicion       = true

      this.form.idSistema    = item.idSistema

      this.form.nombre       = item.nombre

      this.form.descripcion  = item.descripcion

      this.form.icono        = item.icono

      this.form.gradiente    = item.gradiente

      this.form.url          = item.url || ''

      this.modalVisible      = true

    },



    cerrarModal () {

      this.modalVisible = false

    },



    async guardar () {

      if (!this.form.nombre.trim() || !this.form.descripcion.trim()) {

        this.$store.dispatch('mostrarToast', { mensaje: 'El nombre y la descripción son obligatorios', tipo: 'warning' })

        return

      }

      this.guardando = true

      try {

        const res = await servicio.guardar(this.form)

        if (res.data.resultado) {

          this.cerrarModal()

          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })

          await this.cargar()

        } else {

          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })

        }

      } catch {

        this.$store.dispatch('mostrarToast', { mensaje: 'Error al guardar el sistema', tipo: 'error' })

      } finally {

        this.guardando = false

      }

    },



    async cambiarEstatus (item) {

      const nuevoEstatus = item.estatus === 'A' ? 'I' : 'A'

      try {

        const res = await servicio.cambiarEstatus({ idSistema: item.idSistema, estatus: nuevoEstatus })

        if (res.data.resultado) {

          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })

          await this.cargar()

        }

      } catch {

        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cambiar estatus', tipo: 'error' })

      }

    },



    verPlanes (item) {

      this.$router.push({ name: 'AdminPlanes', params: { idSistema: item.idSistema } })

    }

  }

}

</script>



